import {Component} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {DirectoryService} from '../../../services/directory.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {PassOnLogService} from '../../../services/pass-on-log.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'pass-on-log-detailed-view',
    templateUrl: './pass-on-log-detailed-view.component.html',
    styleUrls: ['./pass-on-log-detailed-view.component.scss']
})

export class PassOnLogDetailedViewComponent {
    buildingSelectIsDisabled = false;

    constructor(public api: ApiClientService,
                public passOnLogService: PassOnLogService,
                public directoryService: DirectoryService,
                public authenticationService: AuthenticationService
    ) {}

    onSubmit(data: any): void {
        const url = `/v1/pass_on_log/${this.passOnLogService.selectedItemData.id}.json`;
        this.passOnLogService.api.patch('domainPassOnLog', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            (error) => this.api.errorHandler(error, 'Update failed!')
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.passOnLogService.toggleDetailedView(this.passOnLogService.selectedItemData, true);
        this.passOnLogService.getData();
        if (close) this.passOnLogService.toggleDetailedView(null, false);
    }

    setEditModeFor(item, fieldName: string, state: boolean, form?) {
        if(!this.passOnLogService.selectedItemData.isCanEdit)
            return;
        this.setEditModeForAll(false);
        item.formFields[fieldName].editMode = state;
    }

    setEditModeForAll(state: boolean) {
        for(const field in this.passOnLogService.selectedItemData.formFields)
            this.passOnLogService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField?) {
        if (form.dirty) {
            item[formField] = form.value[formField];
            if(formField == 'building') {
                if(!form.value.building) {
                    toastr.warning('Building must be filled to proceed.');
                    return;
                }
                const building = this.passOnLogService.buildings.find((item) => +item.id === +form.value.building);
                changedValue = {
                    building: {
                        bdId: form.value.building,
                        name: building ? building.name : null
                    }
                };
            }
            this.onSubmit(changedValue);
            if (form.valid) this.setEditModeForAll(false);
        } else {
            this.setEditModeForAll(false);
        }
    }

    showHistory(pass) {
        this.passOnLogService.isPassOnLogHistoryModalShow = true;
        this.passOnLogService.passOnLogInHistoryModal = pass;
    }

    showStatusHistory(pass) {
        this.passOnLogService.isPassOnLogStatusHistoryModalShow = true;
        this.passOnLogService.passOnLogInHistoryModal = pass;
    }

    actionButtonIsNotAvailable() {
        return !this.passOnLogService.selectedItemData.isCanEdit;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/pass-on-log/pass-on-log-detailed-view/pass-on-log-detailed-view.component.ts